import { type Tag, type TagCategory, TagCategoryToDisplayName } from "@albertine/types";
import { tagDisplayName } from "albertine-shared-web";
import type { CategoriesWithUncategorized } from "../../common/types/OfferingCategory";
import { Flex } from "../Common/Flex";
import "./SelectTagsWithCategory.css";
import { getCategorySpecificTags } from "../../common/utils/tags.util";
import Label from "../Common/Label";
import TagComponent from "../Common/Tag";

export const TagToJSXElement: Partial<Record<Tag, React.JSX.Element>> = {
    "price:inexpensive": (
        <span>
            <span>$</span>
            <span style={{ opacity: 0.2 }}>$$$</span>
        </span>
    ),
    "price:moderate": (
        <span>
            <span>$$</span>
            <span style={{ opacity: 0.2 }}>$$</span>
        </span>
    ),
    "price:expensive": (
        <span>
            <span>$$$</span>
            <span style={{ opacity: 0.2 }}>$</span>
        </span>
    ),
    "price:very-expensive": <span>$$$$</span>,
};

type Props = {
    offeringCategory: CategoriesWithUncategorized | undefined;
    values: string[] | undefined;
};

function TagsWithCategories(props: Props) {
    const { offeringCategory, values } = props;

    const tags = values || [];
    const categorySpecificTags = getCategorySpecificTags(offeringCategory);

    if (tags.length === 0) {
        return <Label.Medium.Light.N60>No tags added</Label.Medium.Light.N60>;
    }

    return (
        <Flex.Column gap="large">
            {Object.entries(categorySpecificTags).map((_tags) => {
                const tagCategory = _tags[0] as TagCategory;
                const categoryTags = _tags[1];
                const tagCategoryName = TagCategoryToDisplayName[tagCategory];

                const tagsForCategory = Object.values(categoryTags).filter((tag) =>
                    tags.includes(tag),
                );

                if (tagsForCategory.length === 0) {
                    return null;
                }

                return (
                    <Flex.Row key={tagCategory} alignItems="start">
                        <div className="select-tags__category">
                            <Label.Small.SemiBold>
                                {tagCategoryName}
                            </Label.Small.SemiBold>
                        </div>
                        <Flex.Row gap="medium" wrap="wrap">
                            {tagsForCategory.map((tag) => (
                                <TagComponent.Small.Bold.T90 key={tag}>
                                    {TagToJSXElement[tag] || tagDisplayName(tag, "en")}
                                </TagComponent.Small.Bold.T90>
                            ))}
                        </Flex.Row>
                    </Flex.Row>
                );
            })}
        </Flex.Column>
    );
}

export default TagsWithCategories;
